module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"et":{"Forward":"Edasi","Floor":"Korrus","Apartment number":"Korteri number",". floor":". korrus"}}')
  delete Component.options._Ctor
}
